var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadCrumbs"},[(
      !_vm.getIsBreadCrumbsLoading &&
        _vm.getBreadCrumbs &&
        _vm.getBreadCrumbs.Items.length
    )?_c('div',_vm._l((_vm.displayBreadcrumb),function(item,index){return _c('span',{key:index},[_c('span',{class:[
          {
            'clickable-breadcrumb': item.IsClickable,
            'first-breadcrumb': index === 0,
            bold: index === _vm.displayBreadcrumb.length - 1
          }
        ]},[(item.IsClickable && index !== 0)?_c('a',{attrs:{"href":item.Url}},[_vm._v(" "+_vm._s(item.Title)+" ")]):_c('span',[_vm._v(" "+_vm._s(item.Title)+" ")])]),(index < _vm.displayBreadcrumb.length - 1)?_c('span',[_vm._v(" / ")]):_vm._e()])}),0):_c('div',[_c('Skeleton',{attrs:{"loading":_vm.getIsBreadCrumbsLoading,"width":"60%","height":"21px","marginBottom":"0px"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }